import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	objectDetails: {
		id: 'servicedesk-insight-object-graph.object-view.object-details',
		defaultMessage: 'Object details',
		description: 'Label for tab containing details about a CMDB Object',
	},
	linkedIssues: {
		id: 'servicedesk-insight-object-graph.object-view.linked-issues',
		defaultMessage: 'Linked issues',
		description: 'Label for a tab that lists all issues linking to the current CMDB Object',
	},
	linkedIssuesIssueTermRefresh: {
		id: 'servicedesk-insight-object-graph.object-view.linked-issues-issue-term-refresh',
		defaultMessage: 'Linked work items',
		description: 'Label for a tab that lists all work items linking to the current CMDB Object',
	},
	linkedPages: {
		id: 'servicedesk-insight-object-graph.object-view.linked-pages',
		defaultMessage: 'Linked pages',
		description:
			'Label for a tab that lists all confluence pages linking to the current CMDB Object',
	},
	openObjectDetailsPage: {
		id: 'servicedesk-insight-object-graph.object-view.open-object-details-page',
		defaultMessage: 'Open in object details page',
		description:
			'Tooltip instructing the user to click a link to open the details page for an CMDB Object',
	},
	refreshButton: {
		id: 'servicedesk-insight-object-graph.object-view.refresh-button',
		defaultMessage: 'Refresh',
		description:
			'The button at the bottom of the object details error message which, when clicked, refreshes the object details',
	},
	errorTitle: {
		id: 'servicedesk-insight-object-graph.object-view.error-title',
		defaultMessage: "We couldn't display this object.",
		description: 'Error message instructing user that the object details did not load successfully',
	},
	errorDescription: {
		id: 'servicedesk-insight-object-graph.object-view.error-description',
		defaultMessage: 'Refresh the page and try again.',
		description:
			'Error description instructing user to refresh the page to try again after an error occurred.',
	},
});
